import { ITimelineMediaFrame } from '../../hooks/use-media-item-frames'

export const calculateShownVideoFrames = (
  framesByTime: ITimelineMediaFrame[],
  videoThumbnailWidth: number,
  pixelsPerSecond: number,
  frameSpacing: number,
  _trimStart: number
): (string | null)[] => {
  const framesMinCount =
    Math.ceil(videoThumbnailWidth / (pixelsPerSecond * frameSpacing)) || 1

  if (!framesByTime.length) {
    return Array(framesMinCount).fill(null)
  }

  const framesMap = new Map<number, string>()
  framesByTime.forEach(frame => {
    framesMap.set(frame.timestampSec, frame.url)
  })

  let nearestPreviousFrame: string | null = null

  return Array.from({ length: framesMinCount }, (_, slotIndex) => {
    const slotTimestamp = slotIndex * frameSpacing
    const exactFrame = framesMap.get(slotTimestamp)
    if (exactFrame) {
      nearestPreviousFrame = exactFrame
      return exactFrame
    }

    for (let probe = slotTimestamp - 1; probe >= 0; probe -= 1) {
      const prev = framesMap.get(probe)
      if (prev) {
        nearestPreviousFrame = prev
        return prev
      }
    }

    const next = framesByTime.find(frame => frame.timestampSec > slotTimestamp)
    if (next) {
      nearestPreviousFrame = next.url
      return next.url
    }

    return nearestPreviousFrame
  })
}
